<template>
  <!--  人事科 -->
  <el-container>
    <el-container>
      <!-- 中间内容 -->
      <el-main>
        <h2 class="depTitle">科室考核指标管理</h2>
        <div>
          <el-form class="twoForm" :inline="true">
            <el-form-item>
              <el-select v-model="typeValue" placeholder="请选择科室" clearable filterable  @change="typeValueChange(typeValue)" class="xiangType">
                <el-option v-for="item in depoptions" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <el-table
            :data="DeplisttableData"
            border
            center
        >
          <el-table-column type="index" label="序号" width="55" align="center">
          </el-table-column>
          <el-table-column prop="name" label="科室" align="center">
          </el-table-column>
          <el-table-column prop="updateDate" label="更新时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="220">
            <template style="display: flex" slot-scope="scope">
              <el-button
                  size="mini"
                  type="primary"
                  @click="showDetail(scope.row)"
              >查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="total"
        >
        </el-pagination>
      </el-main>
    </el-container>
    <el-dialog
        :title="fillTitle"
        :visible.sync="FillingVisible"
        :before-close="FillingVisibleClose"
        width="600px"
        top="1vh"
    >
      <el-form
          :model="Performance"
          ref="PerformanceRef"
          :rules="PerformanceRules"
          :inline="true"
          label-width="120px"
      >
        <el-form-item prop="weightScore" class="hosform">
          <div class="tabBig">
            <div class="boxOne">
              权重分值
            </div>
            <div class="line"></div>
            <div class="boxTwo">
              <el-input :disabled="disabled" v-model="Performance.weightScore" :precision="2"></el-input>
            </div>
          </div>
        </el-form-item>

        <el-form-item v-if="btnShow">
          <div class="btnSize">
            <el-button type="primary" v-if="cesuanClick" @click="onsubmit" :loading="cesuanClickTwo">提交数据</el-button>
            <el-button v-else type="info" :loading="cesuanClickTwo"></el-button>
          </div>
        </el-form-item>

      </el-form>
    </el-dialog>

    <el-dialog
        :title="attTit+'考核指标管理'"
        :visible.sync="attendVisible"
        :before-close="attendVisibleClose"
        width="90%"
        top='1vh'
    >
      <el-table
          :data="attentableData"
          border
          center
          :cell-style="cellStyle"
          :header-cell-style="rowClass"
      >
        <el-table-column type="index" label="序号" width="55" align="center">
        </el-table-column>
        <el-table-column prop="name" label="指标名称" align="center" width="300px">
        </el-table-column>
        <el-table-column prop="evaluate" label="评价办法" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="rule"  label="指标分值计算规则" align="center" width="400px">
        </el-table-column>
        <el-table-column prop="weightScore"  label="权重分值" align="center" width="150px">
        </el-table-column>
        <el-table-column label="操作" align="left" width="142px">
          <template style="display: flex;" slot-scope="scope">
            <!--待填写显示填报-->
            <el-button
                size="mini"
                type="primary"
                @click="editIndex(scope.row)"
            >编辑</el-button>
            <!--删除-->
            <el-button size="mini" type="danger" @click="deleteIndex(scope.row)">删除</el-button>
            <!--重置基数-->
<!--            <el-button style="width: 80px;" v-if="scope.row.id !== 7 && scope.row.id !== 6" size="mini" type="primary" @click="calculateBase(scope.row)" :loading="scope.row.remindLoading">重置基数</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </el-container>
</template>

<script>
import _qs from "qs";

export default {
  data() {
    return {
      cesuanClick: true,
      cesuanClickTwo: false,
      attendVisible:false,
      deptId:window.sessionStorage.getItem("deptId"),
      depoptions:[],
      typeValue:"",
      attendstartTime:'',
      disabled:false,
      btnShow:true,
      fillTitle:'填报',
      // 填报
      Performance: {
        // 基数
        cardinal:'',
        // 权重分值
        weightScore:''
      },
      // 绩效分配结构规则
      PerformanceRules: {
        weightScore: [
          {
            required: true,
            message: "请输入权重分值",
            trigger: "blur",
          }
        ]
      },
      // 填报弹出框
      FillingVisible: false,
      // 表格数据
      DeplisttableData: [],
      attentableData:[],
      // 医院id
      hospitalId: window.sessionStorage.getItem("hospitalId"),
      // 总页数
      total: 1,
      // 每页页数
      pageNum: 1,
      // 每页显示条数
      pageSize: 10,

      indexDetailId:'',
      indexName:'',
      cardinal:'',
      weightScore:'',
      attTit:'',
      attDepId:''
    };
  },
  created() {
    this.getDepartmentNotPage()
    // 科室数据查询
    this.findDepartment()
  },
  methods: {
    rowClass({ rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        if(columnIndex===4||columnIndex===5){
          return {background:'#FFFAFA','text-align':'center'}
        }if(columnIndex===6){
          return {'text-align':'center'}
        }
      }
    },
    cellStyle({column}){
      if(column.property === 'weightScore' || column.property === 'cardinal'){
        return {
          background: '#FFFAFA'
        }
      }
    },
    FillingVisibleClose(){
      this.FillingVisible=false
      this.indexDetailId=''
      this.indexName=''
      this.cardinal=''
      this.weightScore=''

      this.Performance= {
        // 基数
        cardinal:'',
        // 权重分值
        weightScore:''
      }
    },
    attendVisibleClose(){
      this.attendVisible=false
      this.attDepId=''
      this.attTit=''
      this.getDepartmentNotPage()
    },
    showDetail(row){
      this.attendVisible=true
      this.attTit=row.name
      this.attDepId=row.id
      this.indexList()
    },
    async indexList() {
      let data = _qs.stringify({
        departmentId:this.attDepId
      });
      let { data: res } = await this.$axios.indexList(data);
      // console.log(res);
      if (res.code == 401) {
        this.$router.push("/login");
      }else if (res.code == 200) {
        this.attentableData = res.rows;
      } else{
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    typeValueChange(val){
      this.typeValue=val
      this.getDepartmentNotPage();
    },
    async findDepartment(){
      let data = {
        hospitalId:window.sessionStorage.getItem("hospitalId"),
        isWorkload:1
      };
      let { data: res } = await this.$axios.findDepartment(data);
      // console.log(res);
      if (res.code == 401) {
        this.$router.push("/login");
      }else if (res.code == 200) {
        this.depoptions = res.data;
      } else{
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    editIndex(row) {
      this.indexDetailId=row.detailsId
      this.indexName=row.name
      this.cardinal=row.cardinal
      this.weightScore=row.weightScore
      this.fillTitle=row.name+'指标编辑'

      this.Performance.cardinal = row.cardinal
      this.Performance.weightScore = row.weightScore


      this.btnShow=true
      this.FillingVisible=true
      this.disabled=false
    },
    // 删除科室下的该指标
    async deleteIndex(row){
      const confirmResult = await this.$confirm("删除后不可恢复，是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);

      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除");
      }

      let data = _qs.stringify({
        id:row.detailsId
      });
      let res = await this.$axios.deleteIndex(data);
      if (res.data.code == 401) {
        this.$router.push("/login");
      } else if (res.data.code == 200) {
        this.$message({
          message: res.data.msg,
          type: "success",
        });
        this.indexList()
        this.FillingVisible=false
      } else {
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
    },
    async calculateBase(row){
      this.$set(row, 'remindLoading', true)
      let data = _qs.stringify({
        id:row.id,
        detailsId:row.detailsId,
        departmentId:this.attDepId
      });
      let res = await this.$axios.calculateBase(data);

      if (res.data.code == 401) {
        this.$router.push("/login");
      } else if (res.data.code == 200) {
        this.$message({
          message: res.data.msg,
          type: "success",
        });
        this.indexList()
        this.FillingVisible=false
      } else {
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
      this.$set(row, 'remindLoading', false)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getDepartmentNotPage();
    },
    //   获取绩效填报列表
    async getDepartmentNotPage() {
      let data = {
        basePeriodTime:this.attendstartTime,//时间
        hospitalId:window.sessionStorage.getItem("hospitalId"),
        id:this.typeValue,
        pageNum: this.pageNum, //页数
        pageSize: this.pageSize, //每页显示数量
        isWorkload: 1
      };
      let { data: res } = await this.$axios.getDepartmentList(data);
      // console.log(res);
      if (res.code == 401) {
        this.$router.push("/login");
      }else if (res.code == 200) {
        this.DeplisttableData = res.rows;
        this.total = res.total;
      } else{
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    onsubmit() {
      this.cesuanClick=false;
      this.cesuanClickTwo=true;
      this.$refs.PerformanceRef.validate(async(valid) => {
        if (valid) {
          let data = _qs.stringify({
            id:this.indexDetailId,
            score:this.Performance.weightScore
          });
          let res = await this.$axios.updateIndexDetail(data);

          // console.log(res);
          if (res.data.code == 401) {
            this.$router.push("/login");
          } else if (res.data.code == 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.indexList()
            this.FillingVisible=false
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.cesuanClick=true;
          this.cesuanClickTwo=false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.tabBig{
  width: 500px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: space-around;
  /deep/ .el-input__inner{
    border:none!important;
  }
  .line{
    height: 40px;
    border: 1px solid #ccc;
  }
  .boxTwo,.boxOne{
    width: 50%;
  }
}

.twoForm {
  float: right;
  display: flex;
}

/deep/ .el-form-item.hosform{
  margin-bottom: 0px!important;
}

/deep/ .el-select.xiangType .el-input--suffix {
  width: 150px !important;
}

.activeStatus {
  background: rgb(102, 204, 0);
}
.noStatus,
.activeStatus {
  width: 25px;
  height: 25px;
  color: white;
  line-height: 25px;
  text-align: center;
  margin: 0 auto;
}

.noStatus {
  background: #ccc;
}
.depTitle {
  display: flex;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 30px;
}

/deep/ .el-radio-button__inner {
  width: 100px;
}
.el-pagination {
  margin-top: 20px;
}

.btnSize button{
  width: 120px;
  margin-top: 20px;
}

/deep/ .el-input-number__decrease,/deep/ .el-input-number__increase{
  display: none;
}

.checRev /deep/ .el-checkbox{
  margin-bottom: 20px;
}

/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #ffffff;
}
</style>
